import { createContext } from 'react'

const GalleryContext = createContext({ basePath: '/' })

export default GalleryContext
